import { Action, createReducer, on } from '@ngrx/store';
import * as LobbyWrapUpPageActions from './actions/wrap-up-page.actions';
import * as LobbyWrapUpApiActions from './actions/lobby-wrap-up-api.actions';
import { LobbyEntryDetail, ProvidedService } from '../../shared/models/lobby-entry-detail';
import { LobbyServiceWithCategory } from '../../shared/models/lobby-service';
import { LobbyServiceCheckList } from '../../shared/models/lobby-service-checklist';



export interface LobbyWrapUpState {
    lobbyEntryDetail: LobbyEntryDetail | null;
    openWrapUpPopUp: boolean;
    showWrapUpButton: boolean;
    serviceFilter: string;
    lobbyServices: LobbyServiceWithCategory[];
    checkListItems: LobbyServiceCheckList[];
    checkListItemsForRequestedService: LobbyServiceCheckList[];
    showCheckListPopUp: boolean;
    showRequestedServiceCheckListPopUp: boolean;
    wrapUpComment: string;
    impersonatedByName: string | null;
    impersonatedByCode: string | null; 
    isImpersonateAssist: boolean;
    currentInteractionProvidedServices:ProvidedService[];
}

const initialLobbyWrapUpState: LobbyWrapUpState = {
    lobbyEntryDetail: null,
    openWrapUpPopUp: false,
    showWrapUpButton: false,
    serviceFilter: '',
    lobbyServices: [],
    checkListItems: [],
    checkListItemsForRequestedService: [],
    showCheckListPopUp: false,
    showRequestedServiceCheckListPopUp: false,
    wrapUpComment: '',
    isImpersonateAssist:false,
    impersonatedByName: null,
    impersonatedByCode: null, 
    currentInteractionProvidedServices: []
};

const reducer = createReducer<LobbyWrapUpState>(
    initialLobbyWrapUpState,
    on(LobbyWrapUpApiActions.assistLobbyEntrySuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            lobbyEntryDetail: action.lobbyEntryDetail,
            isImpersonateAssist: action.isImpersonateAssist,
            impersonatedByName:action.impersonateByName
        }
    )),
    on(LobbyWrapUpApiActions.impersonateAssistLobbyEntrySuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            lobbyEntryDetail: action.lobbyEntryDetail,
            isImpersonateAssist: action.isImpersonateAssist,
            impersonatedByName: action.impersonateByName,
            impersonatedByCode: action.impersonatedByCode
        }
    )),
    on(LobbyWrapUpPageActions.setImpersonateDetails, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,          
            isImpersonateAssist:action.isImpersonate,
        impersonatedByName: action.impersonateByName,
        impersonatedByCode: action.impersonatedByCode

        }
    )),
    on(LobbyWrapUpPageActions.loadWrapUpPopUp, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            isImpersonateAssist: action.isImpersonateAssist,
        impersonatedByName: action.impersonatedByName,
        impersonatedByCode: action.impersonatedByCode
        }
    )),
    on(LobbyWrapUpApiActions.fetchLobbyEntrySuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            lobbyEntryDetail: action.lobbyEntryDetail
        }
    )),
    on(LobbyWrapUpPageActions.hideWrapUp, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            openWrapUpPopUp: false,
            showWrapUpButton: true,
            showCheckListPopUp: false,
            showRequestedServiceCheckListPopUp: false,
            serviceFilter: ''

        }
    )),
    on(LobbyWrapUpApiActions.provideServiceSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            currentInteractionProvidedServices:action.providedServices,
           

        }
    )),
    on(LobbyWrapUpApiActions.removeProvideServiceSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            currentInteractionProvidedServices:action.providedServices,
           

        }
    )),
    on(LobbyWrapUpApiActions.updateProvideServiceReferenceSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            currentInteractionProvidedServices:action.providedServices,
           

        }
    )),
    on(LobbyWrapUpPageActions.closeWrapUp, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            lobbyEntryDetail: null,
            openWrapUpPopUp: false,          
            serviceFilter: '',
            lobbyServices: [],
            checkListItems: [],
            checkListItemsForRequestedService: [],
            showCheckListPopUp: false,
            showRequestedServiceCheckListPopUp: false,
            wrapUpComment: ''
          
        }
    )),
    on(LobbyWrapUpPageActions.showWrapUp, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            openWrapUpPopUp: true,
            showWrapUpButton: action.isImpersonateAssist ?lobbyWrapUpState.showWrapUpButton:false
        }
    )),
    on(LobbyWrapUpApiActions.loadServicesSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            openWrapUpPopUp: true,
            lobbyServices: action.services.map(s => ({
                ...s,
                service: {...s.service, isChecked: false}
            }))
        }
    )),    
    on(LobbyWrapUpApiActions.backToLobbySuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            openWrapUpPopUp: false,
            lobbyEntryDetail: null,
            serviceFilter: '',
            lobbyServices: [],
            checkListItems: [],
            checkListItemsForRequestedService: [],
            showCheckListPopUp: false,
            showRequestedServiceCheckListPopUp: false,
            wrapUpComment: '',
            showWrapUpButton:!action.isImpersonateAssist? false:lobbyWrapUpState.showWrapUpButton
         
        }
    )),
    on(LobbyWrapUpApiActions.getCheckListForServiceeSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            checkListItems: action.checkList,
            showCheckListPopUp: true
        }
    )),
    on(LobbyWrapUpApiActions.getCheckListForRequestedServiceeSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            checkListItemsForRequestedService: action.checkList,
            showRequestedServiceCheckListPopUp: true
        }
    )),
    on(LobbyWrapUpPageActions.closeCheckList, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            checkListItems: [],
            checkListItemsForRequestedService: [],
            showCheckListPopUp: false,
            showRequestedServiceCheckListPopUp: false
        }
    )),
    on(LobbyWrapUpPageActions.closeRequestedServiceCheckList, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            checkListItems: [],
            checkListItemsForRequestedService: [],
            showCheckListPopUp: false,
            showRequestedServiceCheckListPopUp: false
        }
    )),
    on(LobbyWrapUpPageActions.setWrapUpComment, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            wrapUpComment: action.comment
        }
    )),
    on(LobbyWrapUpPageActions.setSearchFilter, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            serviceFilter: action.searchValue
        }
    )),
    on(LobbyWrapUpApiActions.wrapUpSuccess, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            openWrapUpPopUp: false,
            lobbyEntryDetail: null,
            serviceFilter: '',
            lobbyServices: [],
            checkListItems: [],
            checkListItemsForRequestedService: [],
            showCheckListPopUp: false,
            wrapUpComment: ''
          
        }
    )),
    on(LobbyWrapUpPageActions.showEditServiceReference, (lobbyWrapUpState, action): LobbyWrapUpState => (
        {
            ...lobbyWrapUpState,
            lobbyEntryDetail: action.lobbyEntryDetail
        }
    ))
);

export function lobbyWrapUpReducer(state: LobbyWrapUpState | undefined, action: Action) {
    return reducer(state, action);
}
